import { Badge, Button, Card } from "../../design-v2";

function ArrowRightIcon() {
  return (
    <svg
      className="lz-product-program-summary__action-icon"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
  );
}

export default function ProgramSummaryCard({
  eyebrow = "Current Program",
  title,
  status,
  statusTone = "neutral",
  detail,
  progressLabel,
  progressPercent,
  dateRange,
  actionLabel,
  onAction,
  className = "",
  ...props
}) {
  const hasProgress = Number.isFinite(progressPercent);
  const boundedProgress = hasProgress
    ? Math.min(100, Math.max(0, progressPercent))
    : null;

  return (
    <Card
      {...props}
      tone="interactive"
      padding="lg"
      className={["lz-product-program-summary", className].filter(Boolean).join(" ")}
    >
      <div className="lz-product-program-summary__heading">
        <div className="lz-product-program-summary__identity">
          <p className="lz-product-program-summary__eyebrow">{eyebrow}</p>
          <h2 className="lz-product-program-summary__title">{title}</h2>
        </div>
        {status ? (
          <Badge tone={statusTone} className="lz-product-program-summary__status">
            <span className="lz-product-program-summary__status-dot" aria-hidden="true" />
            {status}
          </Badge>
        ) : null}
      </div>

      {detail || progressLabel || dateRange || hasProgress ? (
        <div className="lz-product-program-summary__summary">
          {detail || progressLabel ? (
            <div className="lz-product-program-summary__summary-line">
              <span>{detail || "Progress"}</span>
              {progressLabel ? <strong>{progressLabel}</strong> : null}
            </div>
          ) : null}

          {hasProgress ? (
            <div
              className="lz-product-program-summary__progress"
              role="progressbar"
              aria-label="Program progress"
              aria-valuemin="0"
              aria-valuemax="100"
              aria-valuenow={Math.round(boundedProgress)}
            >
              <span
                className="lz-product-program-summary__progress-fill"
                style={{ width: `${boundedProgress}%` }}
              />
            </div>
          ) : null}

          {dateRange ? (
            <p className="lz-product-program-summary__date-range">{dateRange}</p>
          ) : null}
        </div>
      ) : null}

      {actionLabel && onAction ? (
        <Button
          size="lg"
          className="lz-product-program-summary__action"
          onClick={onAction}
        >
          {actionLabel}
          <ArrowRightIcon />
        </Button>
      ) : null}
    </Card>
  );
}
